let initialState = {
      loading: false,
      authenticated: false,
      token: null,
      role: '',
      settings: {},
      contacts: [],
      relation: {}
  }
export default () => ({
  ...JSON.parse(JSON.stringify(initialState)),
})
